import React from 'react';
import Text from '@amzn/meridian/text';
import { FormattedMessage, useIntl } from 'react-intl';
import { ARCFilters, SIDE_MENU_PATH } from '../Types/types';
import Row from '@amzn/meridian/row';
import BasicFilter from '../../FilterComponent/BasicFilter';
import { FilterIdentity } from '../../FilterComponent/Type/FilterType';
import Page from '../../../../Types/Page';

interface ARCHeadingProps {
  hash: string;
  allTmCount: number;
  allAssociateCount: number;
  directReportCount: number;
  sharedProfileCount: number;
  filter: string;
  verticalOptions: string[];
  verticalValue: string;
  setVerticalValue: React.Dispatch<any>;
}

const ARCHeading: React.FC<ARCHeadingProps> = ({
  hash,
  allTmCount,
  allAssociateCount,
  directReportCount,
  sharedProfileCount,
  filter,
  verticalOptions,
  verticalValue,
  setVerticalValue,
}: ARCHeadingProps): React.ReactElement => {
  const intl = useIntl();
  let verticalFilter;
  if (filter === ARCFilters.PERFORMANCE) {
    verticalFilter = (
      <Row alignmentVertical='top' alignmentHorizontal='justify'>
        <BasicFilter
          label={intl.formatMessage({
            id: 'cs_perfportal_vertical',
            defaultMessage: 'Vertical',
          })}
          value={verticalValue}
          filterOptions={verticalOptions}
          setValue={setVerticalValue}
          identity={FilterIdentity.VERTICAL}
          page={Page.TEAM}
          ccxDetailsPage={undefined}
        />
      </Row>
    );
  }
  if (hash === SIDE_MENU_PATH.ALL_TMS)
    return (
      <Row alignmentHorizontal='justify'>
        <Text type='h400'>
          <FormattedMessage
            id='cs_perfportal_arc_all_tms_heading'
            defaultMessage='All TMs'
          />{' '}
          {`(${allTmCount})`}
        </Text>
        {verticalFilter}
      </Row>
    );

  if (hash === SIDE_MENU_PATH.ALL_ASSOCIATES)
    return (
      <Row alignmentHorizontal='justify'>
        <Text type='h400'>
          <FormattedMessage
            id='cs_perfportal_arc_all_associates_heading'
            defaultMessage='All Associates'
          />{' '}
          {`(${allAssociateCount})`}
        </Text>
        {verticalFilter}
      </Row>
    );
  if (hash === SIDE_MENU_PATH.DIRECT_REPORT)
    return (
      <Row alignmentHorizontal='justify'>
        <Text type='h400'>
          <FormattedMessage
            id='cs_perfportal_arc_direct_reports_heading'
            defaultMessage='Direct Reports'
          />{' '}
          {`(${directReportCount})`}
        </Text>
        {verticalFilter}
      </Row>
    );
  if (hash === SIDE_MENU_PATH.SHARED_PROFILE)
    return (
      <Row alignmentHorizontal='justify'>
        <Text type='h400'>
          <FormattedMessage
            id='cs_perfportal_arc_shared_profiles_heading'
            defaultMessage='Shared Profiles'
          />{' '}
          {`(${sharedProfileCount})`}
        </Text>
        {verticalFilter}
      </Row>
    );
  return <></>;
};

export default ARCHeading;
